import { render, staticRenderFns } from "./Parkings.vue?vue&type=template&id=bdd8c6c2&"
import script from "./Parkings.vue?vue&type=script&lang=js&"
export * from "./Parkings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports